"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var defaultEntry = {
  isIntersecting: false,
  intersectionRatio: 0
};
var defaultOptions = {};

function useElementVisibility() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var ref = react_1.useRef(null);

  var _react_1$useState = react_1.useState(defaultEntry),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      visibility = _react_1$useState2[0],
      setVisibility = _react_1$useState2[1];

  function getObserver() {
    if (ref.current === null) {
      ref.current = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setVisibility(entry);
        });
      }, options);
    }

    return ref.current;
  }

  var observer = getObserver();
  var subscribe = react_1.useCallback(function (node) {
    if (node) {
      observer.observe(node);
    }
  }, [observer]);
  var unsubscribe = react_1.useCallback(function () {
    return observer.disconnect();
  }, [observer]);
  react_1.useEffect(function () {
    return function () {
      observer.disconnect();
    };
  }, [observer]);
  return [visibility, subscribe, unsubscribe];
}

exports.default = useElementVisibility;